// @flow
import JobList from 'components/job/JobList';
import { connect } from 'react-redux';
import { fetchJobList, initialFetchJobList } from 'actions/jobActions';

import type { JobFiltersSearchType } from 'types/JobFilter';
import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/job/JobList';

export default connect(
  (state: StateType): StateProps => ({
    jobs: state.jobListState.jobs,
    maxPage: state.jobListState.maxPage,
    totalJobs: state.jobListState.totalJobs,
    jobFilters: state.jobListState.jobFilters,
    status: state.jobListState.status,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchJobListPreview: (filters: JobFiltersSearchType) => dispatch(fetchJobList(filters)),
    initialFetchJobListPreview: (filters: JobFiltersSearchType) => dispatch(initialFetchJobList(filters)),
  })
)(JobList);
